import {DomainStore} from 'shared/store';
import {action} from 'mobx';

class ExpenseRequestsContainerState {
  store = new DomainStore();

  @action async removeExpenseRequest(expenseRequest) {
    await this.store.destroy(expenseRequest);
  }
}

export default ExpenseRequestsContainerState;
